import { render } from "./ClampedText.vue?vue&type=template&id=702c8baf&scoped=true"
import script from "./ClampedText.vue?vue&type=script&lang=js"
export * from "./ClampedText.vue?vue&type=script&lang=js"

import "./ClampedText.vue?vue&type=style&index=0&id=702c8baf&scoped=true&lang=css"
import "./ClampedText.vue?vue&type=style&index=1&id=702c8baf&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702c8baf"]])

export default __exports__